export const TWO_PI = 2 * Math.PI;

export const PI_BY_180 = Math.PI / 180;
